// extracted by mini-css-extract-plugin
export var content = "cv-module--content--47e46";
export var contentPane = "cv-module--content-pane--a6dea";
export var cvWrapper = "cv-module--cvWrapper--c4b04";